export const AUTHKEY = 'eSignPro-authToken';
export const REFRESHKEY = 'eSignPro-refreshToken';
